import type { ReactNode } from "react";
import { LANGUAGE_NAMES, type FormLanguage } from "./bilingualTexts";

interface BilingualColumnsProps {
  /** The reader's language first (`formLanguages`). */
  languages: readonly [FormLanguage, FormLanguage];
  /** One column's control, given its language (for the control's `lang`) and that language's name for its label. */
  children: (language: FormLanguage, languageName: string) => ReactNode;
}

/** A text in both languages side by side, the reader's first (VF-D-03); stacked where its own pane is narrow (`pane-layouts.css`). */
export default function BilingualColumns({ languages, children }: BilingualColumnsProps) {
  return (
    <div className="app-bilingual">
      <div className="app-bilingual-columns">
        {languages.map((language) => (
          <div key={language} className="min-w-0">
            {children(language, LANGUAGE_NAMES[language])}
          </div>
        ))}
      </div>
    </div>
  );
}
